import React from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  Routes,
  Route,
} from "react-router-dom";

import {
  Profile,
  ChangePassword,
  Preferences,
  Translation,
  MasterConfiguration,
  MenuBuilder,
  MasterView,
  Organisation,
  Site,
  Role,
  Users,
  Department,
  LandingPage,
  Hierarchy,
  NestedHierarchy,
  ConfigurationBulkUpload,
  ChangePasswordBulk,
  CronReRun,
  DailyReportUsers,
  DataBackupConfig,
  WarningLimits,
  FracasPermissions,
  ParameterAlias,
  ColorCodes,
  DashboardConfiguration,
  HmiConfiguration,
  ReportConfiguration,
  ELogBookConfiguration
} from "../pages";
import MasterMapping from "../pages/Settings/MasterMapping";
import DataAlerts from "../pages/Modules/Custom/DataAlerts";

const SettingsRouter = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const propsData = { location, navigate, params };

  const dynamicRouteRender = (routes) => {
    return (
      routes &&
      Array.isArray(routes) &&
      routes.map((route, index) => (
        <Route key={index} {...route} />
      ))
    );
  };

  const routes = [
    { path: "/Profile", element: <Profile {...propsData} /> },
    { path: "/change-password", element: <ChangePassword {...propsData} /> },
    { path: "/changePasswordBulk", element: <ChangePasswordBulk {...propsData} /> },
    { path: "/translation", element: <Translation {...propsData} /> },
    { path: "/preferences", element: <Preferences {...propsData} /> },
    { path: "/UserManagement/Organisation", element: <Organisation {...propsData} /> },
    { path: "/UserManagement/Site", element: <Site {...propsData} /> },
    { path: "/UserManagement/:siteId/Roles", element: <Role {...propsData} /> },
    { path: "/UserManagement/Users", element: <Users {...propsData} /> },
    { path: "/UserManagement/Department", element: <Department {...propsData} /> },
    { path: "/UserManagement/LandingPage", element: <LandingPage {...propsData} /> },
    { path: "/MenuConfiguration", element: <MenuBuilder {...propsData} /> },
    { path: "/Hierarchy", element: <Hierarchy {...propsData} /> },
    { path: "/Hierarchy/:hierarchyname", element: <NestedHierarchy {...propsData} /> },
    { path: "/Hierarchy/:hierarchyname/:parentId", element: <NestedHierarchy {...propsData} /> },
    { path: "/master/:mastercode", element: <MasterView {...propsData} /> },
    { path: "/ParameterAlias", element: <ParameterAlias {...propsData} /> },
    { path: "/ColorCodes", element: <ColorCodes {...propsData} /> },
    { path: "/DataAlerts", element: <DataAlerts {...propsData} /> },
    { path: "/MasterMapping", element: <MasterMapping {...propsData} /> },
    { path: "/MasterConfiguration", element: <MasterConfiguration {...propsData} /> },
    { path: "/ConfigurationBulkUpload", element: <ConfigurationBulkUpload {...propsData} /> },
    { path: "/CronReRun", element: <CronReRun {...propsData} /> },
    { path: "/Configuration", element: <DataBackupConfig {...propsData} /> },
    { path: "/DailyReportUsers", element: <DailyReportUsers {...propsData} /> },
    { path: "/WarningLimits", element: <WarningLimits {...propsData} /> },
    { path: "/FracasPermissions", element: <FracasPermissions {...propsData} /> },

    { path: '/dashboardConfiguration', element: <DashboardConfiguration {...propsData} /> },
    { path: '/hmiConfiguration', element: <HmiConfiguration  {...propsData} /> },
    { path: '/reportConfiguration', element: <ReportConfiguration  {...propsData} /> },
    { path: '/eLogbookConfiguration', element: <ELogBookConfiguration {...propsData} /> },

  ];

  return (
    <div>
      <Routes>{dynamicRouteRender(routes)}</Routes>
    </div>
  );
};

export default SettingsRouter;
